import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const PUBLIC_EMAIL_DOMAINS = [
    'gmail.com',
    'outlook.com',
    'outlook.cz',
    'yahoo.com',
    'hotmail.com',
    'hotmail.cz',
    'aol.com',
    'protonmail.com',
    'zoho.com',
    'yandex.com',
    'mail.com',
    'gmx.com',
    'icloud.com',
    'fastmail.com',
    'tutanota.com',
    'mail.ru',
    'hushmail.com',
    'airmail.net',
    'lycos.com',
    'netcourrier.com',
    'zimbra.com',
    'rediffmail.com',
    'mailinator.com',
    'msn.com',
    // Seznam
    'seznam.cz',
    'email.cz',
    'post.cz',
    // Centrum (Economia)
    'centrum.cz',
    'volny.cz',
    'atlas.cz',
    // Tiscali
    'tiscali.cz',
    // SK
    'azet.sk',
    'centrum.sk',
    'zoznam.sk',
    'iol.cz',
];

export const DAYS_PLURALS = ['den', 'dny', 'dní'];

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function pluralize(count: number, words: string[]) {
    if (count === 1) return words[0];
    if (count >= 5 || count === 0) return words[2];
    return words[1];
}

export function parseTime(timeInSeconds: number) {
    const minutes: number = Math.floor(timeInSeconds / 60);
    const seconds: number = timeInSeconds - minutes * 60;

    return { minutes, seconds };
}

export function transformLaravelToFormikErrors(errors: {
    [index: string]: string[];
}) {
    const formikErrors: { [index: string]: string } = {};
    for (const key in errors) formikErrors[key] = errors[key].join('\n');
    return formikErrors;
}

export function floatToString(num: number, fixed = 0) {
    return num.toFixed(fixed).replace('.', ',');
}
